'use strict';
const React = require('react');
const Link = require('../elements/SVTLink');
const FooterLinkList = (props) => {
		const items = props.model.items;
		return (
			<div className="svtse_footer-service">
				{items.map(function (item, index) {
					return (
						<span key={index} className="svtse_footer-service__item">
							<Link className="svtse_footer-service__link" to={item.url}>{item.title}</Link>
						</span>
					);
				})}

				<figure>
					<Link to="/" className="svtse_footer-logo__link">
						<img className="svtse_footer-logo__img" alt="SVT.se logotyp" src="/static/svtse-render/images/logotypes/svtlogo-white.svg" />
					</Link>
					<figcaption className="svtse_footer-logo__text">
					&copy; Sveriges Television AB
					</figcaption>
				</figure>
			</div>
		);
};

module.exports = FooterLinkList;



/** WEBPACK FOOTER **
 ** ./app/components/Footer/FooterService.js
 **/